const post_url: string = 'admin-report';

export const GetAdminReport = async (): Promise<any> => {
       return await $fetch(post_url, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const CreateAdminReport = async (report: any): Promise<any> => {
       return await $fetch(post_url, {
              method: "POST", headers: FetchHeader(), body: report, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetUnreadReport = async (userId: string): Promise<any> => {
       return await $fetch(`${post_url}/unread-report`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const ReadReport = async (reportId: string): Promise<any> => {
       return await $fetch(`${post_url}/${reportId}/read`, {
              method: "PUT", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GeneratePdfReport = async (reportId: string): Promise<any> => {
       return await $fetch(`${post_url}/${reportId}/pdf`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};
 